import { render, staticRenderFns } from "./CircleCharts.vue?vue&type=template&id=5673271a&scoped=true"
import script from "./CircleCharts.vue?vue&type=script&lang=ts"
export * from "./CircleCharts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673271a",
  null
  
)

export default component.exports